import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  signal,
} from '@angular/core';
import { Button } from 'primeng/button';
import { PrimeIcons } from 'primeng/api';
import {
  FormComponent,
  ResponseErrorBoxComponent,
  SubmitMethod,
} from '@tokenbox/utils';
import { AuthService, TeamInvitationsCrudService } from '@tokenbox/services';

@Component({
  selector: 'dt-team-invitation-buttons',
  templateUrl: './team-invitation-buttons.component.html',
  styleUrls: ['./team-invitation-buttons.component.scss'],
  imports: [Button, ResponseErrorBoxComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamInvitationButtonsComponent implements FormComponent {
  readonly teamId = input.required<string>();

  protected readonly PrimeIcons = PrimeIcons;
  private invitationsCrudService = inject(TeamInvitationsCrudService);
  private authService = inject(AuthService);
  currentUserEmail = this.authService.email;

  loading = signal(false);
  responseError = signal<Error | null>(null);
  successfullySubmitted = signal(false);

  @SubmitMethod()
  async deleteInvitation() {
    const currentUserEmail = this.currentUserEmail();
    if (currentUserEmail) {
      await this.invitationsCrudService.deleteInvitation(
        this.teamId(),
        currentUserEmail,
      );
    }
  }

  @SubmitMethod()
  async acceptInvitation() {
    await this.invitationsCrudService.acceptInvitation(this.teamId());
  }
}
